export default __webpack_public_path__ + "static/media/301.de72d868.gif";